import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class dpDialog {
    static classname = 'js-dp-dialog';

    constructor($dialog) {
        const $title = $dialog.find('.js-dp-dialog-title');
        $title.text($title.text().replace('выдачив', 'выдачи в'));
    }
}